
import './style.scss'

interface AdBannerHomeProps {
	onClick?: () => void
}

function AdBannerHome({onClick}: AdBannerHomeProps) {

	const onBannerClick = () => {
		if (onClick) {
			onClick()
		}
	}

	return (
		<div 
			className='ad-banner-home'
			onClick={() => { onBannerClick() }}
		>
			<span className='ad-banner-home-bold'>First Session For Free!</span> No cost, just progress. Create your profile today!
		</div>
	)
}

export default AdBannerHome